<template>
  <div class="contacts-wrapper">
    <InnerHeader
      :cover="require('../../assets/img/contacts/cover.jpg')"
      :bgColor="'#0095D4'"
      :bgPosition="'0 20%'"
    />
    <div class="contacts">
      <div class="decoration-element">
        <div class="decoration-element-2"></div>
      </div>
      <CompaniesList />
      <p class="text-info">
        <a href="/files/info.pdf" target="_blank">Информация относно условията и реда за подаване на сигнали по ЗЗЛПСПОИН</a>
      </p>
    </div>
  </div>
</template>

<script>
import InnerHeader from '../shared/InnerHeader';
import CompaniesList from '../kcmGroup/CompaniesList';
export default {
  components: {
    InnerHeader,
    CompaniesList
  }
};
</script>

<style lang="scss" scoped>
.contacts {
  padding: 50px 0;
  position: relative;
}
.text-info {
  margin-top: -25px;
  padding: 0 25px;
  text-align: center;
  a {
    color: #0057BB;
    font-size: 10px;
    text-decoration: underline;
    @include transition(all 0.6s $mainCubic);

    &:hover {
      opacity: 0.8;
    }
  }
}
@media screen and (max-width: 1600px) {
  .contacts {
    padding: 50px 0;
  }
}
@media screen and (max-width: 1280px) {
  .contacts {
    padding: 40px 0;
  }
}
@media screen and (max-width: 600px) {
  .contacts {
    padding: 20px 0;
  }
}
</style>
